export default __webpack_public_path__ + "static/media/silver_raven_insignia.f5e9b4a2.png";